import * as actionTypes from 'modules/interventions/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @typedef {boolean} IsOpenState */

/** @type {IsOpenState} */
const initialState = false;

const open = () => true;
const close = () => false;

export default createReducer(initialState, {
  [LOCATION_CHANGE]: close,
  [actionTypes.OPEN_TSCANS_IMPORT_MODAL]: open,
  [actionTypes.CLOSE_TSCANS_IMPORT_MODAL]: close,
  [actionTypes.IMPORT_AUDITS_OR_TSCANS_SUCCESS]: close,
});
